
<template>
    <!-- <div :class="[upspring ? 'family-num margin-btm' :'family-num']"> -->
    <div :class="['family-num', {'margin-btm':upspring}]">
        <van-nav-bar title="亲情号" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
        <p class="family-title">{{markedWords}}</p>
        <div class="family-box" v-for="(item,index) in familyNum" :key="index">
          <div class="family-flex">
              <p>名称</p>
              <van-field
              v-model="item.name"
              placeholder="请输入家庭成员名称"
              :border="false"
              @focus="keyboardTop(true)"
              @blur="keyboardTop(false)"
              />
              <div class="family-img"></div>
          </div>
          <div class="family-flex">
              <p>亲情号码{{index+1}}</p>
              <van-field
              v-model="item.phone"
              placeholder="请填写手机号码"
              :border="false"
              type="number"
              :maxlength="11"
              @focus="keyboardTop(true)"
              @blur="keyboardTop(false)"
              />
              <img class="family-img" src="@/assets/images/family_number.png" background-size="cover" @click="showAddress(index)" />
          </div>
        </div>
        <div class="btn-box">
            <van-button round type="info" @click="save">保存</van-button>
        </div>
        <van-popup v-model="show" position="bottom" closeable round @close="close">
            <div class="pop-content">
                <span class="device-title">通讯录</span>
                <div class="auto-box">
                    <div class="no-data-center" v-if="deviceList.length<=0">
                    通讯录暂无号码
                    </div>
                    <template v-else>
                    <div class="device-information" v-for="(item,index) in deviceList" :key="index" @click="checkThis(item)">
                        <div class="device-name">
                        <img class="information-img" src="@/assets/images/morentouxiangbeifen.png" background-size="cover" />
                        <p>{{item.name}}</p>
                        </div>
                        <div class="device-phone">
                        <p>{{item.sim}}</p>
                        </div>
                    </div>
                    </template>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="frequentFlag" round @close="close">
            <div class="fill-number">
                <img class="fill-img" src="@/assets/images/address_list.png" background-size="cover" />
                <p>提示</p>
                <span>通讯录为空，请先添加常用联系人</span>
                <div class="fill-btn">
                <van-button @click="close" class="fill-cancel" type="primary">取消</van-button>
                <van-button class="fill-confirm" type="primary" @click="goAddress">确定</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nameValue:'',//名称
            iphoneValue:'',//电话号码
            markedWords:'',//提示语
            familyNum:[
                {
                name:'',
                phone:''
                },
                {
                name:'',
                phone:''
                },
                {
                name:'',
                phone:''
                }
            ],
            show:false,//通讯录
            flag:false,//显示通讯录or提示
            frequentFlag:false,//无联系人提示
            updateIndex:null,//修改的联系人是哪一个
            deviceList:[
                {
                name:'ddd',
                sim:'454454545'
                }
            ],//通讯录列表
            upspring:false,//键盘是否弹起
        };
    },
    created() {
        this.close()
        this.getSupportList()
        // this.resizeScreen()
    },
    methods: {
        /**
         * 获取设备支持的指令列表
         */
         getSupportList(){
          let data = {
            ver:1,
            method:'getDeviceAllInfo'
          }
          this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
              if (res.code === 0) {
                this.$store.commit('set_devTypeList', JSON.stringify(res.data.instructionList))
                this.getFamilyNum()
                this.getAddressList()
              } else {
                wx.showToast({
                  title: res.msg,
                  icon: "none"
                });
              }
          })
        },
        //监听键盘弹起
        resizeScreen(){
          var originHeight = document.documentElement.clientHeight || document.body.clientHeight;
          this.$nextTick(()=>{
            // let bodyE = document.querySelector('.family-num');
            window.addEventListener('resize', function() {
                var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                if (originHeight < resizeHeight) {
                    console.log('Android 键盘收起啦！');
                    // Android 键盘收起后操作
                    // bodyE.style.height = 100+'%';
                } else {
                    console.log('Android 键盘弹起啦！');
                    // Android 键盘弹起后操作
                    // bodyE.style.height = originHeight+'px';
                    window.scrollTo(0, 500);
                }
                // originHeight = resizeHeight;
            }, false)
          });
        },
        /**
         * 键盘弹起
         */
        keyboardTop(bool){
          // if(this.upspring===bool)return
          this.upspring = bool
          window.scrollTo(0, 500);
          // if(bool){
          //   // console.log(document.documentElement.scrollTop,66)
          //   // const gap = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
          //   // document.documentElement.scrollTop = 1000
          //   window.scrollTo(0, 500);
          // }
        },
        close(){
            this.frequentFlag = false
            this.show = false
        },
        /**
         * 增加通讯录
         */
        goAddress(){
            this.$router.push({ name: 'addMail'});
        },
        /**
         * 点击通讯录
         */
        checkThis(item){
            this.familyNum[this.updateIndex].name =  item.name
            this.familyNum[this.updateIndex].phone =  item.sim
            this.show = false
        },
        /**
         * 打开通讯录
         */
        showAddress(index){
            this.updateIndex = index
                if(this.flag){
                    this.frequentFlag = true
                }else{
                    this.show = true
                }
        },
        /**
         *获取亲情号列表
            */
        getFamilyNum(){
            let data = {
                ver:1,
                method:'getInstructById',
                instructionId:this.$intfilter.instructFilter('亲情号码')
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                  this.markedWords = res.data.explain?res.data.explain:'亲情号1，2，3分别对应设备上1/2/3号按键，当分别按下后设备会给对应的手机号拨打电话'
                  let arr = res.data.params!=''?res.data.params.split(','):[]
                  for (let i = 0; i < arr.length/2; i++) {
                      this.familyNum[i].name = arr[i*2]
                      this.familyNum[i].phone = arr[i*2+1]
                  }
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
        },
        /**
         *获取白名单列表
            */
        getAddressList(){
            let data = {
            ver:1,
            method:'getInstructById',
            instructionId:this.$intfilter.instructFilter('白名单')
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                this.deviceList = []
                if(res.data.params===""){
                    this.flag = true
                    return
                }else{
                    this.flag = false
                }
                let arr = res.data.params.split(',')
                for (let i = 0; i < arr.length/2; i++) {
                    this.deviceList.push({
                    name:arr[i*2],
                    sim:arr[i*2+1]
                    })
                }
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
        },
        /**
         * 保存亲情号
         */
        save(){
            let flag = false,str='';
            this.familyNum.forEach((item,index) => {
                str+=(item.name+','+item.phone+',')
                if((item.name=="" && item.phone=="") || (item.name!="" && item.phone!=""))return
                flag = true;
            });
            if(flag){
                this.$toast("请正确填写输入信息")
                return
            }
            let data = {
                ver:1,
                method:'sendInstruct',
                params:str,
                instructionId:this.$intfilter.instructFilter('亲情号码')
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    this.$toast({
                        message: "保存成功",
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/correct.png'),
                    });
                    let timer = setTimeout(()=>{
                        that.getFamilyNum()
                        clearTimeout(timer)
                    },1000)
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
        },
        /**
         * 返回上一级
         */
        backPage() {
            this.$router.back(-1);
        },
    }
};
</script>

<style lang="scss" scoped>
.family-num{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 40px 0;
}
.margin-btm{
  padding-bottom: 400px;
}
.family-title{
  margin-top: 60px;
  font-size: 26px;
  font-weight: 400;
  color: #666666;
}
.family-box{
  margin-top: 40px;
  width: 100%;
  height: 202px;
  background: #FFFFFF;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.family-flex{
  display: flex;
  align-items: center;
}
.family-flex>p{
  width: 260px;
  margin-left: 32px;
  font-size: 30px;
  font-weight: 600;
  color: #666666;
}
.family-img{
  width: 32px;
  height: 32px;
  margin: 0 32px;
}
.pop-content{
  background-color: #fff;
  position: relative;
}
.pop-content .device-title{
  font-size: 34px;
  font-weight: 600;
  color: #111;
  display: flex;
  justify-content: center;
  padding: 40px 0 60px 0;
}
.auto-box{
  height: 400px;
  overflow: auto;
}
.no-data-center{
  line-height: 400px;
  text-align: center;
}
.pop-content  .device-information{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  padding: 0 60px;
  margin-bottom: 40px;
}
.device-information .device-name{
  display: flex;
  align-items: center;
  font-size: 28px;
}
.device-information .device-name .information-img{
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
.device-information .device-phone{
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 28px;
}
.device-information .device-phone .information-img{
  width: 46px;
  height: 46px;
  margin-left: 30px;
}
.fill-number{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 32px 32px;
}
.fill-number>p{
  margin: 40px 0 3px;
  font-size: 36px;
  font-weight: 600;
  color: #111111;
}
.fill-number>span{
  margin: 30px 0 10px;
  font-size: 26px;
  font-weight: 400;
  color: #666666;
}
.fill-number .fill-img{
  width: 356px;
  height: 192px;
}
.fill-number .fill-btn{
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style lang="scss">
.family-num  .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background-color: #01ADA9;
}
.family-num ._van-field{
  flex: 1;
  color: #111111;
  font-size: 30px;
}
.family-num .fill-number .van-button{
  width: 200px;
  height: 68px;
}
.family-num .fill-number .fill-cancel{
  margin-right: 36px;
  background: #FFFFFF;
  border-radius: 34px;
  color: #01ADA9;
  border: 2px solid #01ADA9;  
}
.family-num .fill-number .fill-confirm{
  background: #01ADA9;
  border-radius: 34px;
  border: 2px solid #01ADA9;
  color: #fff;
}
.family-num .fill-number .van-field__control{
  text-align: center;
}
.family-num{
    .van-nav-bar{
        background-color: #F8F8F8;
        width: 100%;
    }
}
</style>